export default {
    login_register: 'Zaloguj się/Zarejestruj',
    booking_confirmation_title: 'Potwierdzenie rezerwacji',
    booking_confirmation_body: 'Dziękujemy za dokonanie rezerwacji. Szczegóły potwierdzenia znajdziesz poniżej.',
    insurance_requirements_modal_disclaimer: `Dokonując tej rezerwacji, potwierdzam, że: nie miałem/am wyroków ani wykroczeń drogowych w ciągu ostatnich 5 lat. Nie odmówiono mi propozycji, nie anulowano polisy ani nie odmówiono odnowienia, nie wymagano ode mnie wyższej składki ani nie nałożono specjalnych warunków przez żadnego ubezpieczyciela komunikacyjnego. Nie zostałem/am pozbawiony/a prawa jazdy. Nie mam wszczętego postępowania sądowego ani dochodzenia policyjnego. Nie mam wyroków za kradzież, oszustwo lub nieuczciwość w ciągu ostatnich 5 lat. Nie cierpię na wady wzroku lub słuchu (niekorygowane okularami lub aparatem słuchowym), choroby serca, cukrzycę, napady lub jakąkolwiek fizyczną lub psychiczną niepełnosprawność. Nie miałem/am żadnych wypadków w ciągu ostatnich 5 lat. Kliknij {0}, jeśli nie spełniasz tych wymagań.`,
    insurance_requirements_here: 'tutaj',
    insurance_requirements: 'Przeczytałem/am i rozumiem {0}',
    ir: 'Wymagania ubezpieczeniowe',
    location: 'Lokalizacja',
    pickup_location: 'Miejsce odbioru',
    dropoff_location: 'Miejsce zwrotu',
    vehicle: 'Pojazd',
    pickup_and_dropoff: 'Odbiór i zwrot (czas lokalny)',
    view_voucher: 'Zobacz voucher',
    identity_verification_body: 'Przed odbiorem pojazdu będziesz musiał/a potwierdzić swoją tożsamość',
    identity_verification_title: 'Weryfikacja tożsamości',
    search_again: 'Szukaj ponownie',
    refrigerated: 'chłodzony',
    aircon_lower: 'klimatyzacja',
    aircon: 'Klimatyzacja',
    refrigeration: 'Chłodzony',
    not_available: 'Drive & Go jest obecnie dostępny tylko dla osób z dokumentami tożsamości i prawa jazdy z następujących krajów.',
    check_if_included: 'Sprawdź, czy Twój kraj jest na liście.',
    included_in_booking: 'Uwzględnione w tej rezerwacji',
    cdw_with_excess: 'CDW z udziałem własnym',
    theft_protection: 'Ochrona przed kradzieżą z udziałem własnym',
    risk_reduction: 'Redukcja ryzyka',
    free_extras: 'Przysługują Ci dwa darmowe dodatki <br /> do tej rezerwacji.',
    continue: 'Kontynuuj',
    luggage_large_short_label: 'D',
    luggage_medium_short_label: 'Ś',
    luggage_small_short_label: 'M',
    luggage_large_long_label: 'duża',
    luggage_medium_long_label: 'średnia',
    luggage_small_long_label: 'mała',
    fuel_unspecified_label: 'nieokreślone',
    transmission_manual_label: 'Manualna',
    transmission_automatic_label: 'Automatyczna',
    make_a_booking: 'Zarezerwuj',
    pickup_date: 'Data odbioru',
    dropoff_date: 'Data zwrotu',
    driver_age: 'Kierowca w wieku 30-65 lat',
    enter_driver_age: 'Podaj wiek kierowcy',
    promo_code: 'Kod promocyjny',
    search: 'Szukaj',
    dropoff_date_cannot_be_before_pickup_date: 'Data zwrotu nie może być wcześniejsza niż data odbioru',
    pickup_date_cannot_be_in_the_past: 'Data odbioru nie może być w przeszłości',
    pickup_time_cannot_be_in_the_past: 'Godzina odbioru nie może być w przeszłości',
    dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'Godzina zwrotu musi być późniejsza niż godzina odbioru, jeśli to ten sam dzień',
    vehicle_filters: 'Filtry pojazdów',
    reset: 'Resetuj',
    transmission: 'Skrzynia biegów',
    all: 'Wszystkie',
    manual: 'Manualna',
    auto: 'Automatyczna',
    passengers: 'Pasażerowie',
    vehicle_type: 'Typ pojazdu',
    filter: 'Filtruj',
    vehicle_search: 'Wyszukiwanie pojazdu',
    edit: 'Edytuj',
    no_results: 'Brak wyników spełniających kryteria.',
    small_cars: 'Małe samochody',
    medium_cars: 'Średnie samochody',
    large_cars: 'Duże samochody',
    estate_cars: 'Kombi',
    suvs: 'SUV-y',
    mpvs: 'Vany',
    vans: 'Dostawcze',
    camper_vans: 'Kampery',
    premium: 'Premium',
    unspecified: 'nieokreślone',
    large: 'duży',
    medium: 'średni',
    small: 'mały',
    automatic: 'automatyczna',
    you_have_been_refunded: 'Otrzymałeś/aś zwrot środków.',
    please_customer_service: 'Aby dokonać rezerwacji, skontaktuj się z naszym działem obsługi klienta.',
    contact_customer_service: 'Kontakt z obsługą klienta',
    booking_failed: 'Nie udało się przetworzyć rezerwacji.',
    summary: 'Podsumowanie',
    reforestation_and_protection: 'Wspieraj zalesianie i ochronę lasów deszczowych w Kostaryce',
    cost_of_rental: 'Koszt wynajmu',
    to_pay_now: 'Do zapłaty teraz',
    greenheart_donation: 'Darowizna Green Heart',
    total_cost: 'Całkowity koszt wynajmu',
    tc_agreement: 'Przeczytałem/am i rozumiem {0}.',
    tc: 'Regulamin',
    receive_offers: 'Chcę otrzymywać oferty specjalne na e-mail.',
    donate: 'Tak, chcę przekazać {amount}',
    pay_now: 'Zapłać {amount} teraz',
    driver_details: 'Dane kierowcy',
    complete_driver_details: 'Uzupełnij dane kierowcy.',
    are_you_the_driver: 'Czy jesteś kierowcą?',
    have_an_account: 'Masz już konto?',
    login: 'Zaloguj się',
    or: 'lub',
    first_name: 'Imię kierowcy',
    last_name: 'Nazwisko kierowcy',
    email: 'Adres e-mail',
    phone_number: 'Numer telefonu komórkowego',
    unable_to_save_driver_information: 'Nie można zapisać danych kierowcy. Spróbuj ponownie.',
    pay_online_now: 'Zapłać teraz',
    day: 'Dzień',
    choose_location: 'Wybierz lokalizację',
    location_not_found: 'Nie znaleziono podanej lokalizacji.',
    add: 'Dodaj',
    remove: 'Usuń',
    free_extra: 'Darmowy dodatek',
    free: 'DARMOWE!',
    fast_track_notice: 'Ograniczenia dotyczące pochodzenia dokumentów mają zastosowanie do tej usługi. Dostępne tylko dla osób z dokumentami z',
    complete_booking: 'Zakończ rezerwację',
    choose_card: 'Wybierz kartę lub dodaj nową.',
    add_billing_details: 'Dodaj dane do faktury.',
    card_number: 'Numer karty',
    card_holder_name: 'Imię i nazwisko posiadacza karty',
    card_exp: 'MM / RR',
    card_cvc: 'CVC',
    save_card: 'Zapisać kartę?',
    amount_charged: 'Twoja karta zostanie obciążona',
    payment_confirmation: 'Potwierdź rezerwację i zapłać',
    payment_methods: 'dostępne metody płatności',
    use_saved_card: 'x użyj zapisanej karty',
    use_different_card: '+ użyj innej karty',
    book_now: 'Rezerwuj teraz',
    minimum_age: 'Tylko dla osób powyżej {age} lat',
    excess_liability: 'Udział własny',
    security_deposit: 'Depozyt',
    fuel_policy: 'Polityka paliwowa',
    like_for_like: 'Tyle ile było',
    full_to_full: 'Pełny do pełnego',
    miles_per_rental: '{mileage} darmowych mil na wynajem',
    km_per_rental: '{mileage} darmowych km na wynajem',
    unlimited_mileage: 'Nielimitowany przebieg',
    unlimited_mileage_km: 'Nielimitowane km',
    non_amendable: 'Nieedytowalne',
    non_refundable: 'Bezzwrotne',
    free_cancellation_until: 'Darmowa anulacja do',
    cancellation_in_line_with: 'Anulacja zgodnie z',
    tcs: 'Regulamin',
    free_extras_on_collection: 'Dwa darmowe dodatki przy odbiorze',
    glass_and_tyres_covered: 'Szyby i opony w cenie',
    number_of_passengers: 'Liczba pasażerów',
    number_of_bags: 'Liczba bagaży',
    fuel_type: 'Rodzaj paliwa',
    co2: 'CO2',
    book_type: 'Zarezerwuj {type}',
    processing: 'Przetwarzanie',
    actual_price: 'Cena końcowa',
    tooltip: 'Cena w {currencyCode} jest szacunkowa na podstawie kursu, cena w {currency} jest wiążąca.',
    deposit: 'Depozyt',
    pay_online: 'Zapłać teraz',
    pay_online_without_extras: 'Cena wynajmu',
    extras_on_arrival: 'Dodatki przy odbiorze',
    insurance_on_arrival: 'Redukcja ryzyka - zapłać przy odbiorze',
    insurance_online: 'Redukcja ryzyka - zapłać teraz',
    extras_online: 'Dodatki - zapłać teraz',
    green_heart_donation: 'Darowizna Green Heart',
    why_use_drive_and_go: 'Dlaczego warto wybrać Drive & Go?',
    straight_to_car: 'Prosto do auta',
    no_queues: 'Brak kolejek',
    self_checkout: 'Samodzielny odbiór',
    cant_lose_key: 'Nie można zgubić kluczyka',
    online_id_check: 'Weryfikacja tożsamości online',
    phone_as_key: 'Telefon jako klucz',
    premiumplus_benefits_includes: 'W cenie także korzyści Premium Plus+',
    book_drive_go: 'Zarezerwuj Drive & Go',
    distance_allowance: 'Limit dystansu',
    duration: 'Czas trwania',
    view_more_bookings: 'Zobacz więcej rezerwacji',
    to_pay_on_arrival: 'Do zapłaty przy odbiorze',
    pay_on_arrival: 'Zapłać przy odbiorze',
    unlimited: 'Nielimitowane',
    return_date: 'Data zwrotu',
    postcode: 'Kod pocztowy',
    country: 'Kraj',
    drive_and_go: {
        drive_and_go: 'Drive And Go',
        available_countries: 'Drive & Go jest obecnie dostępny tylko dla osób z dokumentami tożsamości i prawa jazdy z następujących krajów:',
        drive_and_go_today: 'Rezerwacja Drive & Go na dziś!',
        drive_and_go_shortened: 'Drive & Go',
        why_use_drive_and_go: 'Dlaczego warto wybrać Drive & Go?',
        straight_to_car: 'Prosto do auta',
        no_queues: 'Brak kolejek',
        self_checkout: 'Samodzielny odbiór',
        cannot_lose_the_key: 'Nie można zgubić kluczyka',
        online_id_check: 'Weryfikacja tożsamości online',
        phone_as_a_key: 'Telefon jako klucz',
        premium_plus_benefits_also_included: 'W cenie także korzyści Premium Plus+',
        book_drive_and_go: 'Zarezerwuj Drive & Go',
    },
    car_and_camp: {
        tent_and_equipment: 'Namiot i wyposażenie',
        quick_and_easy: 'Szybki i łatwy montaż',
        travel_freedom: 'Wolność podróżowania',
        affordable_campervan_alternative: 'Przystępna cenowo alternatywa dla kampera',
        lightweight_and_compact: 'Lekki i kompaktowy',
        fully_insured: 'W pełni ubezpieczony',
    },
    my_bookings: 'Moja rezerwacja',
    no_bookings: 'Brak rezerwacji',
    my_profile: 'Mój profil',
    no_bookings_to_display: 'Brak rezerwacji do wyświetlenia.',
    search_great_car_rental_deals: 'Szukaj świetnych ofert wynajmu samochodów na swoją następną podróż.',
    odometer_at_collection: 'Licznik przy odbiorze',
    fuel_at_collection: 'Paliwo przy odbiorze',
    start_check_in: 'Rozpocznij check-in',
    start_collection: 'Rozpocznij odbiór',
    recent_bookings: 'Ostatnia rezerwacja',
    damage: {
        updated_damage_report_submitted: 'Zaktualizowany raport o uszkodzeniach został przesłany. Skontaktuje się z Tobą nasz zespół obsługi klienta, jeśli będzie to konieczne.',
        add_additional_damage: 'Dodaj dodatkowe uszkodzenie',
        you_may_report_additional_damage_up_to: 'Możesz zgłosić dodatkowe uszkodzenia do 24 godzin po odbiorze pojazdu',
        specify_damage: 'Określ uszkodzenie',
        please_choose_the_area_and_type_of_damage: 'Wybierz miejsce i rodzaj uszkodzenia',
        type_of_damage: 'Rodzaj uszkodzenia',
        is_this_more_than_5_cm: 'Czy to więcej niż 5 cm?',
        please_take_or_select_a_photo: 'Zrób lub wybierz zdjęcie',
        please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Zrób zdjęcie, aby uszkodzenie było wyraźnie widoczne',
        if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' W razie potrzeby możesz dodać kolejne zdjęcie, wybierz ikonę, aby dodać kolejne',
        save_image: 'Zapisz zdjęcie',
        save_images: 'Zapisz zdjęcia',
        damage_saved_successfully: 'Uszkodzenie zapisane pomyślnie',
        add_photo: 'Dodaj zdjęcie',
    },
    checkout: {
        start_collection: 'Rozpocznij odbiór',
        collect_vehicle: 'Odbierz pojazd',
        we_will_let_you_know_the_details: 'Poinformujemy Cię o lokalizacji i szczegółach, abyś mógł znaleźć wynajęty pojazd.',
        inspect: 'Sprawdź',
        we_will_ask_for_four_photos_from_each_corner: 'Poprosimy o cztery zdjęcia z każdego rogu pojazdu oraz o wszelkie nowe uszkodzenia, które nie zostały wcześniej zgłoszone.',
        fuel_and_milage: 'Paliwo i przebieg',
        you_confirm_the_readings_at_the_start_of_your_hire: 'Potwierdzasz stan licznika i paliwa na początku wynajmu.',
        sign: 'Podpisz',
        sign_the_rental_agreement: 'Podpisz umowę najmu.',
        away_you_go: 'Szerokiej drogi',
        you_are_free_to_take_to_the_road: 'Możesz ruszać w drogę!',
        collect_your_vehicle: 'Odbierz swój pojazd',
        get_directions: 'Pokaż trasę',
        hide_directions: 'Ukryj trasę',
        local_time: 'czas lokalny',
        tel: 'Tel',
        getting_to_the_location: 'Dojazd do lokalizacji',
        get_vehicle_details: 'Szczegóły pojazdu',
        view_map: 'Zobacz mapę',
        unlock_vehicle_and_continue: 'Odblokuj pojazd i kontynuuj',
        unable_to_connect_to_vehicle: 'Nie można połączyć się z pojazdem',
        we_were_unable_to_connect_to_the_vehicle_please_check: 'Nie udało się połączyć z pojazdem – sprawdź, czy jesteś przy właściwym pojeździe i spróbuj ponownie.',
        we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Nie udało się znaleźć rezerwacji pojazdu. Spróbuj ponownie później.',
        odometer_and_fuel: 'Licznik i paliwo',
        odometer: 'Licznik',
        please_confirm_the_odometer_and_fuel_readings: 'Jeśli to możliwe, potwierdź stan licznika i paliwa.',
        the_odometer_field_is_required: 'Pole licznik jest wymagane',
        and_must_be_greater_than_the_checkout_odometer: 'i musi być większe niż licznik przy odbiorze',
        confirm: 'Potwierdź',
        please_take_a_photo_from_each_corner_of_the_vehicle: 'Zrób zdjęcie z każdego rogu pojazdu',
        pre_existing_damage: 'Istniejące uszkodzenia',
        no_pre_existing_damage: 'Brak istniejących uszkodzeń.',
        new_damage: 'Nowe uszkodzenie',
        add_additional_damage: 'dodaj dodatkowe uszkodzenie',
        no_new_damage_to_report: 'Brak nowych uszkodzeń do zgłoszenia',
        checkout_complete: 'Odbiór zakończony',
        start_rental: 'Rozpocznij wynajem',
        congratulations_name_it_is_time_to_take_to_the_road: 'Gratulacje {customer_name}, czas ruszać w drogę!',
        we_are_unable_to_complete_your_vehicle_checkout: 'Nie możemy zakończyć odbioru pojazdu.',
        please_do_the_following: 'Wykonaj następujące czynności',
        remove_all_belonging_and_lock_the_vehicle: 'Usuń wszystkie rzeczy i zamknij pojazd.',
        lock_vehicle: 'Zamknij pojazd',
        once_you_have_contacted_customer_services: 'Po kontakcie z obsługą klienta',
        vehicle_location: 'Lokalizacja pojazdu',
        collect_your: 'Odbierz swój',
        from: 'Z',
        key_in_glove_box: 'klucz znajduje się w schowku',

        keyholder: {
            not_detected: 'Nie wykryto klucza w uchwycie',
            not_detected_please_try_again: 'Umieść klucz w uchwycie i spróbuj ponownie.',

            not_installed: 'Uchwyt na klucz nie jest zainstalowany',
            not_installed_please_contact_customer_service: 'Uchwyt na klucz nie jest zainstalowany, skontaktuj się z obsługą klienta.',
        },
        keyring: {
            look_up_failed: 'Nie udało się znaleźć uchwytu na klucz',
            look_up_failed_please_contact_customer_service: 'Nie udało się znaleźć uchwytu na klucz, skontaktuj się z obsługą klienta.',
        },
        key: {
            invalid: 'Klucz jest nieprawidłowy',
            invalid_please_contact_customer_service: 'Twój klucz jest nieprawidłowy, skontaktuj się z obsługą klienta.',

            expired: 'Klucz wygasł',
            expired__please_contact_customer_service: 'Twój klucz wygasł, skontaktuj się z obsługą klienta.',
        },
    },
    checkin: {
        start_check_in: 'Rozpocznij check-in',
        vehicle_location: 'Lokalizacja pojazdu',
        tell_us_where_you_have_parked: 'Powiedz nam, gdzie zaparkowałeś pojazd.',
        fuel_and_milage: 'Paliwo i przebieg',
        you_confirm_the_readings_at_the_end_of_your_hire: 'Potwierdzasz stan licznika i paliwa na końcu wynajmu.',
        inspect: 'Sprawdź',
        we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage:
            'Poprosimy o cztery zdjęcia z każdego rogu pojazdu oraz o wszelkie nowe uszkodzenia powstałe podczas wynajmu.',
        lock: 'Zamknij',
        check_you_have_left_no_belonging_then_lock_the_vehicle: 'Sprawdź, czy nie zostawiłeś rzeczy, a następnie zamknij pojazd.',
        please_tell_us_where_you_have_parked_the_vehicle: 'Powiedz nam, gdzie zaparkowałeś pojazd',
        once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Po zamknięciu pojazdu nie będzie można go ponownie otworzyć.',
        name_please_check_you_have_left_no_belongings_then_lock_the_vehicle: '{first_name}, sprawdź, czy nie zostawiłeś rzeczy, zamknij pojazd i w razie potrzeby zwróć fizyczny klucz do uchwytu.',
        lock_vehicle: 'Zamknij pojazd',
        complete_check_in: 'Zakończ check-in',
        inspection: 'Inspekcja',
        complete_vehicle_check_in: 'Zakończ check-in pojazdu',
        we_are_unable_to_complete_your_vehicle_check_in: 'Nie możemy zakończyć check-in pojazdu.',
        please_contact_customer_services: 'Skontaktuj się z obsługą klienta',
        once_you_have_contacted_customer_services: 'Po kontakcie z obsługą klienta',
        please_amend_odometer_to_be_greater_than: 'Zmień licznik na większy niż {odometer_value}',
    },
    rental_agreement: {
        rental_agreement: 'Umowa najmu',
        agreement_between: 'Umowa pomiędzy',
        and: 'i',
        sign_rental_agreement: 'Podpisz umowę najmu',
        i_have_read_and_understood_the_terms_and_conditions: 'Przeczytałem/am i rozumiem regulamin oraz akceptuję stan pojazdu',
    },
    additional_options: 'Dodatkowe opcje',
    booking_details: 'Szczegóły rezerwacji',
    price_for_x_days: 'Cena za {qty_of_days} dzień | Cena za {qty_of_days} dni',
    cancelled: 'Anulowano',
    upcoming: 'Nadchodzące',
    active: 'Aktywne',
    full_insurance_no_deposit: 'Pełne ubezpieczenie i brak wymaganego depozytu',
    excess: '{amount} udział własny',
    deposit: '{amount} depozytu',
    included_daily_distance: '{distance} {unit} dziennie',
    miles: 'mile',
    kilometers: 'kilometry',
    collection_details_title: 'Szczegóły odbioru',
    collection_details_not_found: 'Brak zdefiniowanych szczegółów odbioru dla tej lokalizacji',
    free_cancellation: 'Darmowa anulacja',
    no_deposit: 'Brak depozytu',
    benefit_from: 'Skorzystaj z',
    for_only_per_day: 'Za jedyne {price} dziennie',
    upgrade_mee: 'UpgradeMee',
};
